import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService, NbThemeService, NbMediaBreakpointsService } from '@nebular/theme';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthUser } from '@hm_app/@core/models/auth_user';
import { Struttura } from '@hm_app/@core/models/struttura';
import { LayoutService } from '@hm_app/@core/utils';

import { BASE_PATH_MOODLE } from '@src/environments/configs';
import { environment } from '@src/environments/environment';
// import { AnalyticsService } from "@hm_app/@core/utils/analytics.service";

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Input() position = 'normal';

  user: AuthUser;
  userPictureOnly: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  get current_struttura_gravidanza(): Struttura {
    return this.hmService.current_struttura_gravidanza;
  }
  cancelStruttura(event) {
    this.hmService.removeStrutturaPercorsoGravidanza().subscribe();
  }


  adminMenu = [
    {
      link: '/auth/update-profile',
      title: 'Aggiorna Profilo',
    },
    {
      link: '/admin/profilo',
      title: 'Profilo',
    },
    {
      link: '/auth/logout',
      title: 'Log out',
    },
  ];


  userMenu = [
    {
      link: '/users/profilo',
      title: 'Profilo',
    },
    {
      link: '/users/sync-cup',
      title: 'Sincronizzazione con CUP',
    },
    {
      link: '/auth/logout',
      title: 'Log out',
    },
  ];

  get currentMenu() {
    if (!this.user) {
      return this.publicMenu;
    }
    if (this.user.isAdminOrOperator || this.user.isMonitor) {
      return this.adminMenu;
    }

    if (this.user.isUser) {
      return this.userMenu;
    }
    return this.publicMenu;
  }

  publicMenu = [
    {
      link: '/auth/login',
      title: 'Autenticati',
    },
  ];

  contact_link_text: string;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private hmService: HappyMammaService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.user = this.hmService.auth_user;
    this.hmService.auth_user$.subscribe((user: AuthUser) => {
      this.user = user;
    });
    this.user = this.hmService._auth_user;

    if (!this.user || this.user.isUser)
      this.contact_link_text = 'Contattaci';
    else
      this.contact_link_text = 'Assistenza';

    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();

    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  startSearch() {
    // this.analyticsService.trackEvent("startSearch");
  }

  navigateToLogin(event) {
    if (environment['redirect_login']) {
      window.location.href = environment['redirect_login'];
      return
    }
    this.router.navigate(['/auth/login']);
  }

  async navigateToMoodle() {
    const otp = await this.hmService.getOtp().toPromise();
    const url = BASE_PATH_MOODLE + '/login/index.php?otp=' + otp;
    window.open(url, '_blank');
  }

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';


}
